export enum CommissionDivisionType {
  NONE = "NONE",
  TWO_YEARS = "TWO_YEARS",
  THREE_YEARS = "THREE_YEARS",
}
